import { ISelectionsTransfer } from './ISelectionsTransferRequest';
export * from './IOrderBy';
export * from './IFileSignRequest';
export * from './IRegister';
export * from './IChangePassword';
export * from './auth';

export type ISelectionsTransferRequest = ISelectionsTransfer;
